// extracted by mini-css-extract-plugin
module.exports = {"deletePackageButton":"styles_deletePackageButton__16mEt"};